// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadingDisplayMemeApproval {
    display: block;
    width: auto;
    max-width: 16em;
    max-height: 13em;
    margin-left: auto;
    margin-right: auto;
    border-radius: 15px;
    animation: fadeInGlobal 1s;
    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
}

.manualApprovalLine {
    border: 1px solid var(--GrayBlue);
}

.manualApprovalContainerText {
    padding: 2em;
}

.manualApprovalContainerText p {
    color: var(--settingsTextColor);
    text-align: center;
    font-size: 0.8em;
}

.manualApprovalContainerText h4 {
    color: var(--HighlightBlue);
    text-align: center;
    font-size: 1em;
}

.manualApprovalContainerText h5 {
    color: var(--settingsTextColor);
    text-align: center;
    font-size: bold;
    font-size: 0.9em;
}

.manualApprovalContainerNoImage {
    min-height: 26.8em;
}

.manualApprovalContainerImage {
    padding-top: 2em;
    min-height: 15em;
    max-height: 15em;
}
.manualApprovalTextOrImageDisplay{
    min-height: 20em;
}
.manualApprovalDisplayName {
    text-align: center;
    color: var(--HighlightBlue);
}

.manualApprovalTextDisplay {
    font-size: 0.8em;
    color: var(--settingsTextColor);
}

.manualApprovalButtonContainer {
    display: flex;
}

.LoadingDisplayManualApproval {
    display: flex;
    justify-content: center;
    align-items: center;  
    min-height:31.8em;
}


`, "",{"version":3,"sources":["webpack://./src/components/Applications/memeApproval/settings/memeApprovalCss.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,uDAAuD;IACvD,oDAAoD;IACpD,+CAA+C;AACnD;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB","sourcesContent":[".loadingDisplayMemeApproval {\n    display: block;\n    width: auto;\n    max-width: 16em;\n    max-height: 13em;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 15px;\n    animation: fadeInGlobal 1s;\n    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n}\n\n.manualApprovalLine {\n    border: 1px solid var(--GrayBlue);\n}\n\n.manualApprovalContainerText {\n    padding: 2em;\n}\n\n.manualApprovalContainerText p {\n    color: var(--settingsTextColor);\n    text-align: center;\n    font-size: 0.8em;\n}\n\n.manualApprovalContainerText h4 {\n    color: var(--HighlightBlue);\n    text-align: center;\n    font-size: 1em;\n}\n\n.manualApprovalContainerText h5 {\n    color: var(--settingsTextColor);\n    text-align: center;\n    font-size: bold;\n    font-size: 0.9em;\n}\n\n.manualApprovalContainerNoImage {\n    min-height: 26.8em;\n}\n\n.manualApprovalContainerImage {\n    padding-top: 2em;\n    min-height: 15em;\n    max-height: 15em;\n}\n.manualApprovalTextOrImageDisplay{\n    min-height: 20em;\n}\n.manualApprovalDisplayName {\n    text-align: center;\n    color: var(--HighlightBlue);\n}\n\n.manualApprovalTextDisplay {\n    font-size: 0.8em;\n    color: var(--settingsTextColor);\n}\n\n.manualApprovalButtonContainer {\n    display: flex;\n}\n\n.LoadingDisplayManualApproval {\n    display: flex;\n    justify-content: center;\n    align-items: center;  \n    min-height:31.8em;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
